import Model from '@/models/Model.js';

export default class Notification extends Model {
    static entity = 'notifications';

    static fields() {
        return {
            id: this.attr(null),
            data: this.attr(null),
            notifiable_id: this.attr(null),
            notifiable_type: this.attr(null),
            read_at: this.attr(null),
            type: this.attr(null),

            ...super.fields(),
        };
    }

    static updateStatus(notificationId, status) {
        return this.api().put(`/api/notifications/${notificationId}`, {
            read: status,
        });
    }
}
